<template>
  <div>
    <header-nav :cur="3"/>
    <!-- 搜索 -->
    <div class="nav">
      <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="infor">班级</span>
                </span>
        <div class="newbox">
          <div>
            <div class="newtop">班级学习中心</div>
            <div class="newbot">加入班级，更快速的成长</div>
          </div>
          <div class="input">
            <input placeholder="请输入您想要寻找的课程" type="text"/>
            <div class="select">搜索</div>
          </div>
        </div>
      </div>
    </div>

    <!--学科简介-->
    <div class="xkjj"  v-if="bid!=null">
      <div class="title">学科简介</div>
      <img :src="$api.url+borad.bktp"/>
      <div class="xkjj_cont">
           {{borad.bksm}}
       
      </div>
    </div>

    <!-- 学科分类 -->
  <!--  <div class="navtab">
      <div class="type bacground">
        <div class="ul">学科类型：&nbsp;</div>
        <ul>
          <li v-for="(item, index) in xklx_list" :key="index" :class="{ color: index === int }"
              @click="actli(item.id,index)">{{ item.subjectName }}
          </li>
        </ul>
      </div>
    </div>
 -->



    <!-- 学科列表 -->
    <div class="navtab">
      <div class="listbox" @click="tolist(item.wid)" v-for="(item, index) in clazz_list" :key="index">
        <div class="secodebox">
          <img :src="$api.url+item.clazzImage" alt=""/>
          <div>
            <div class="title">
              {{ item.clazzName }}
              <span class="color1" v-if="item.isCertificate==1">需要考试</span>
              <span class="color2" v-if="item.isExam==1">结业证书</span>
            </div>
            <div class="time">
              <span>带班老师：{{ item.clazzContactPeople }}</span>
              <span>浏览人数：{{ item.viewCount }}人</span>
              <span>开课时间：{{ item.startTime }}</span>
            </div>
            <div class="tent">
              {{ item.clazzDescribe }}
            </div>
          </div>
        </div>

        <div class="bottom">
          <!-- ￥{{item.clazzPrice}} -->
          <div class="butten" @click="toClazzInfo(item.id)">
            <img src="../../assets/img/grade/apply.svg" alt=""/>
            立即报名
          </div>
        </div>
      </div>
    </div>
    <v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum'
                  @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>

    <!-- <paging /> -->
    <footer-nav/>
  </div>
</template>
<script>
import pagination from '@/components/common/pagination'
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
//import paging from '../../components/Paging.vue';
export default {
  components: {
    'v-pagination': pagination,
    'header-nav': headerNav,
    'footer-nav': footerNav,
  },
  data() {
    return {
	  bid:null,
      int: 100,
      sub_subject_int: 0,
      xxlx_int: 0,
      order: ['最新教程', '最多学习', '好评最多'],
      total: 1,
      pageCount: 1,
      pageSize: 12,
      pageNum: 1,
      clazz_list: [],
      xklx_list: [],
      ejxk_list: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        courseName: null,
        parentSubjectId: null,
        subjectId: null,
      },
	  borad:null
    };
  },
  created() {
	this.bid = this.$route.query.bid;
	this.getBoradInfo(this.bid);
    this.queryParentSubjectList();
    this.getList();
  },
  methods: {
	getBoradInfo(bid) {
	    this.$http.get(this.$api.url + '/papi/education_plate/'+bid).then((response) => {
	      this.borad = response.data.data;
	    }, (response) => {
	      console.log("response" + response.data.rows.length);
	    });
	},
    pagechange(currentPage) {
      console.log(currentPage);
      this.queryParams.pageNum = currentPage;
      // ajax请求, 向后台发送 currentPage, 来获取对应的数据
      this.getList();
    },
	
    getList() {
      this.$http.get(this.$api.url + '/papi/clazz/list', {params: this.queryParams}).then((response) => {
        this.clazz_list = [];
        this.clazz_list = response.data.rows;
        this.total = response.data.total;
      }, (response) => {
        console.log("response" + response.data.rows.length);
      });
    },
    actli(id, int) {
      this.int = int;
      console.log(id);
      //this.querySubSubjectList(id);
      this.queryParams.parentSubjectId = id;
      this.getList();
    },
    queryParentSubjectList() {
      // Lambda写法
      this.$http.get(this.$api.url + '/papi/subject/queryParentSubjectList').then((response) => {
        this.xklx_list = [];
        this.xklx_list = response.data.data;
      }, (response) => {
        console.log("response" + response.data.length);
      });
    },
    querySubSubjectList(parentId) {
      // Lambda写法
      this.$http.get(this.$api.url + '/papi/subject/querySubSubjectList', {params: {'parentId': parentId}}).then((response) => {
        this.ejxk_list = response.data.data;
      }, (response) => {
        console.log("response" + response.data.length);
      });
    },
    actliSubSubjectId(id, int) {
      this.sub_subject_int = int;
      this.subSubjectId = id;
    },
    actli2(int) {
      this.int = int;
    },
    toClazzInfo(id) {
      //this.$router.push('/grade/list');
      this.$router.push({path: '/clazz/clazz-info', query: {id: id}});
    },
    toapply(id) {
      this.$router.push({path: '/clazz/inforregist', query: {id: id}});
    },
  },
};
</script>
<style lang="less" scoped>
   // 公共
   .navtab {
     width: 1280px;
     margin: 0 auto;
   }
   
   .color {
     color: #2961EF !important;
   }
   
   .ignore {
     overflow: hidden;
     text-overflow: ellipsis;
     display: -webkit-box;
     -webkit-box-orient: vertical;
     -webkit-line-clamp: 3;
   }
   
   // 搜索
   .nav {
     background: #f7f8fa;
     width: 100%;
     height: 177px;
   
     .top {
       display: block;
       font-size: 16px;
   
       font-weight: 300;
       color: #777777;
       padding: 19px 0 24px;
   
       .infor {
         color: #2961EF;
       }
     }
   
     .newbox {
       display: flex;
       justify-content: space-between;
       align-items: center;
   
       .newtop {
         font-size: 26px;
         color: #000000;
         margin-bottom: 5px;
       }
   
       .newbot {
         font-size: 16px;
         color: #888888;
       }
   
       .input {
         width: 497px;
         height: 59px;
         background: #ffffff;
         box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
         border-radius: 30px;
         position: relative;
   
         input {
           border: none;
           position: absolute;
           left: 30px;
           top: 0;
           height: 59px;
           line-height: 59px;
           width: 365px;
           font-size: 16px;
   
           font-weight: 300;
           color: #777777;
         }
   
         .select {
           position: absolute;
           right: 12px;
           top: 8px;
           width: 74px;
           height: 43px;
           line-height: 43px;
           background: #2961EF;
           border-radius: 30px;
           font-size: 16px;
   
           font-weight: 300;
           color: #ffffff;
           text-align: center;
         }
       }
     }
   }
   
   // 学科分类
   .bacground {
     background: #f7f8fa;
   }
   
   .type {
     margin: 0 0 20px 0;
     padding: 14px 17px;
   
     border-radius: 5px 5px;
     border: 1px solid #e3e8f2;
   
     .ul {
       font-size: 16px;
       color: #333333;
       display: inline-block;
       vertical-align: text-top;
       width: 7%;
       margin-top: 3px;
     }
   
     ul {
       display: inline-block;
       vertical-align: text-top;
       // float: right;
       width: 93%;
   
       li {
         display: inline-block;
         font-size: 16px;
         color: #888888;
         margin-right: 30px;
         line-height: 30px;
   
       }
     }
   
     .add {
       margin-top: 15px;
     }
   
     .addul {
       margin-top: 18px;
     }
   }
   
   .brder {
     border-top: none;
     margin: 0 0 21px;
     border-radius: 0px 0px 0px 0px;
   
     .ul {
       margin-top: 3px;
     }
   
     .add {
       margin: 0;
     }
   }
   
   // 学科列表
   .listbox {
     padding: 11px;
     display: inline-block;
     align-items: center;
     background: #f7f8fa;
     display: flex;
     justify-content: space-between;
     align-items: center;
     margin-bottom: 28px;
     border-radius: 5px;
     border: 1px solid #e3e8f2;
   
     .secodebox {
       cursor: pointer;
       display: flex;
     }
   
     img {
       width: 220px;
       height: 140px;
       vertical-align: middle;
       margin-right: 20px;
     }
   
     .title {
       font-size: 20px;
       color: #333333;
       font-weight: 400;
   
       span {
         padding: 3px 14px;
         font-size: 14px;
         border-radius: 5px 5px 5px 5px;
       }
   
       .color1 {
         border: 1px solid #b4d4f8;
         color: #2961EF;
         background: rgba(180, 212, 248, 0.5);
         margin: 0 7px 0 16px;
       }
   
       .color2 {
         border: 1px solid #f8d1b4;
         color: #ff6c00;
         background: rgba(248, 209, 180, 0.5);
       }
     }
   
     .time {
       display: inline-block;
       font-size: 14px;
       color: #888888;
       position: relative;
       margin: 10px 0 14px;
   
       span {
         vertical-align: middle;
         padding: 0 20px;
         height: 10px;
         border-right: 1px solid rgba(119, 119, 119, 0.82);
         // &::after {
         //     content: '';
         //     height: 18px;
         //     width: 1px;
         //     position: absolute;
         //     right: 10px;
         //     top: 0;
         // }
         &:nth-child(1) {
           padding: 0 20px 0 0;
         }
   
         &:nth-child(3) {
           border-right: none;
         }
       }
     }
   
     .tent {
       font-size: 14px;
       font-weight: 300;
       color: #777777;
       width: 760px;
       text-indent: 2em;
     }
   
     .bottom {
       font-size: 25px;
       color: #2961EF;
       text-align: center;
       margin: 0 28px 0 75px;
   
       .butten {
         cursor: pointer;
         width: 130px;
         height: 37px;
         line-height: 37px;
         background: #2961EF;
         border-radius: 24px 24px 24px 24px;
         text-align: center;
         font-size: 16px;
         color: rgba(255, 255, 255, 1);
         margin: 27px auto 0;
   
         img {
           width: 19px;
           height: 19px;
           margin-right: 5px;
         }
       }
     }
   }
   
   
   //学科简介
   .xkjj {
     width: 1280px;
     height: auto;
     padding:10px 25px 25px 25px;
     box-sizing: border-box;
     display: block;
     margin: 25px auto;
     border: 5px solid #2961EF;
     border-radius: 10px;
     background: #f3f6ff;
     display: flex;
     justify-content: space-between;
     flex-wrap: wrap;
     .title {
       width: 100%;
       line-height: 40px;
       font-weight: bold;
       font-size: 18px;
       color: #2961EF;
       margin-bottom: 10px;
     }
     img{
       width: 350px;
       height: 220px;
       margin-right: 20px;
       display: inline-block;
     }
     .xkjj_cont{
     width: calc(100% - 370px);
       height: 220px;
       overflow-y: auto;
       display: inline-block;
       p{
         width: 100%; height: auto; line-height: 31px; font-size: 16px; color: #666; text-indent: 2em;
         margin-bottom: 8px;
       }
     }
   }
   
   
</style>
<style lang="less" scoped>
.paging {
  width: 534px;
  height: 50px;
  background: rgba(112, 112, 112, 0.18);
  border-radius: 37px 37px 37px 37px;
  margin: 35px auto;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #888888;
  justify-content: space-around;
  text-align: center;

  div {
    height: 50px;
    line-height: 50px;
    border-right: 1px solid rgba(112, 112, 112, 0.2);
    width: 20%;

    &:nth-child(5) {
      border: none;
    }
  }
}
</style>